import http from './http';

export interface Beneficiary {
  name: string;
  relationship: string;
  percentage?: number;
  accountType?: string;
  policyId?: string;
  bankName?: string;
  assetDescription?: string;
}

export interface BeneficiaryDesignationsData {
  id?: string;
  lifeInsuranceBeneficiaries?: Beneficiary[];
  retirementAccountBeneficiaries?: Beneficiary[];
  bankAccountBeneficiaries?: Beneficiary[];
  investmentAccountBeneficiaries?: Beneficiary[];
  otherBeneficiaries?: Beneficiary[];
  lastReviewedDate?: string;
  additionalNotes?: string;
  isLocked?: boolean;
}

class BeneficiaryDesignationsService {
  async createBeneficiaryDesignations(data: Omit<BeneficiaryDesignationsData, 'id'>): Promise<BeneficiaryDesignationsData> {
    const response = await http.post('/api/beneficiary-designations', data);
    return response.data.data || response.data;
  }

  async updateBeneficiaryDesignations(id: string, data: Partial<BeneficiaryDesignationsData>): Promise<BeneficiaryDesignationsData> {
    const response = await http.patch(`/api/beneficiary-designations/${id}`, data);
    return response.data.data || response.data;
  }

  async getBeneficiaryDesignationsById(id: string, targetUserId?: string): Promise<BeneficiaryDesignationsData> {
    const url = targetUserId
      ? `/api/beneficiary-designations/${id}?targetUserId=${targetUserId}`
      : `/api/beneficiary-designations/${id}`;
    const response = await http.get(url);
    return response.data.data || response.data;
  }

  async getAllBeneficiaryDesignations(targetUserId?: string): Promise<BeneficiaryDesignationsData[]> {
    const url = targetUserId
      ? `/api/beneficiary-designations?targetUserId=${targetUserId}`
      : '/api/beneficiary-designations';
    const response = await http.get(url);
    return response.data.data || response.data;
  }

  async deleteBeneficiaryDesignations(id: string): Promise<void> {
    await http.delete(`/api/beneficiary-designations/${id}`);
  }

  async lockBeneficiaryDesignations(id: string): Promise<void> {
    await http.post(`/api/beneficiary-designations/${id}/lock`);
  }

  async unlockBeneficiaryDesignations(id: string, emails: string[]): Promise<void> {
    await http.post(`/api/beneficiary-designations/${id}/unlock`, { emails });
  }

  async getBeneficiaryDesignationsAccessGrants(id: string): Promise<any[]> {
    const response = await http.get(`/api/beneficiary-designations/${id}/access-grants`);
    return response.data.data || response.data;
  }
}

export const beneficiaryDesignationsService = new BeneficiaryDesignationsService();
